import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface Props {
  status: "unpublished" | "ready" | "published" | "archived";
  className?: string;
}

export function PublicAdoptionListingStatusBadge({ status, className }: Props) {
  if (status === "unpublished") {
    return (
      <Badge variant="secondary" className={cn(className)} data-testid="badge-profile-status-unpublished">
        Unpublished
      </Badge>
    );
  }
  if (status === "ready") {
    return (
      <Badge
        className={cn(
          "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
          className,
        )}
        data-testid="badge-profile-status-ready"
      >
        Ready
      </Badge>
    );
  }
  if (status === "published") {
    return (
      <Badge
        className={cn(
          "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
          className,
        )}
        data-testid="badge-profile-status-published"
      >
        Published
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className={cn("text-muted-foreground", className)} data-testid="badge-profile-status-archived">
      Archived
    </Badge>
  );
}
